import { createContext, useState, useContext, useEffect, useRef } from 'react';
import { formatearJsonProductos, toastSuccess } from './functions';
import axiosRequest from './axiosRequest';
//import axios from "./axios";

const ContextoGlobal = createContext();

export const useContextoGlobal = () => {
    return useContext(ContextoGlobal);
};

export const ProveedorContextoGlobal = ({ children }) => {
    const carritoGuardado = JSON.parse(localStorage.getItem("carrito")) || [];
    const [mostrarLoader, setMostrarLoader] = useState(true);
    const [cargaError, setCargaError] = useState(false);
    const [itemsCarrito, setItemsCarrito] = useState([]);
    
    const primeraCarga = useRef(true);

    useEffect(() => {
        const ids = carritoGuardado.map(product => product.id);
        axiosRequest.get(`/products?include[]=${ids.join("&include[]=")}`)
            .onResponse((response) => {
                const productosConCantidad = formatearJsonProductos(response.data).map((producto) => {
                    const productoGuardado = carritoGuardado.find(
                        (item) => item.id === producto.id
                    );
                    return {
                        ...producto,
                        cantidad: productoGuardado ? productoGuardado.cantidad : 1,
                    };
                });
                setItemsCarrito(productosConCantidad);
            })
            .onCatch(function (error) {
                setCargaError(true)
            })
            .onFinally(()=>{
                setMostrarLoader(false)
            })
    }, []);

    useEffect(() => {
        if (!cargaError && !primeraCarga.current) {
            const carritoParaGuardar = itemsCarrito.map(producto => ({
                id: producto.id,
                cantidad: producto.cantidad
            }));
            localStorage.setItem('carrito', JSON.stringify(carritoParaGuardar));
        } else if (cargaError)
            setCargaError(false);
        primeraCarga.current = false;
    }, [itemsCarrito]);

    const agregarItemsCarrito = (nuevoItem, cantidad = 1) => {
        setItemsCarrito((prevItems) => {
            if (itemsCarrito.find(item => item.id === nuevoItem.id)) {
                return prevItems.map(item =>
                    item.id === nuevoItem.id
                        ? { ...item, cantidad: item.cantidad + cantidad }
                        : item
                );
            } else {
                return [...itemsCarrito, { ...nuevoItem, cantidad }];
            }
        })
        toastSuccess('Producto agregado al carrito')
    };
    const cambiarCantidadItem = (idItem, cantidad) => {
        setItemsCarrito(prevItems =>
            prevItems.map(item =>
                item.id === idItem
                    ? { ...item, cantidad: cantidad }
                    : item
            )
        );
    };
    const removerItemCarrito = (idItem) => {
        setItemsCarrito(itemsCarrito.filter(item => item.id !== idItem));
    };
    const obtenerCantidadItems = () => {
        return itemsCarrito.length;
    };

    return (
        <ContextoGlobal.Provider value={{
            itemsCarrito, agregarItemsCarrito, removerItemCarrito,
            mostrarLoader, cambiarCantidadItem, obtenerCantidadItems
        }}>
            {children}
        </ContextoGlobal.Provider>
    );
};
